import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AdminPanel from './components/admin/AdminPanel';
import AuthenticatedLayout from './components/AuthenticatedLayout';
import './App.css';

const PrivateRoute = ({ children }) => {
  const { currentUser, loading } = useAuth();
  if (loading) return <div className="loading-screen">Cargando...</div>;
  return currentUser ? children : <Navigate to="/login" replace />;
};

const AdminRoute = ({ children }) => {
  const { currentUser, isAdmin, loading } = useAuth();
  if (loading) return <div className="loading-screen">Cargando...</div>;
  if (!currentUser) return <Navigate to="/login" replace />;
  return isAdmin ? children : <Navigate to="/" replace />;
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={
            <PrivateRoute>
              <AuthenticatedLayout title="Inicio" subtitle="Registro de asistencia">
                <Dashboard />
              </AuthenticatedLayout>
            </PrivateRoute>
          } />
          <Route path="/admin" element={
            <AdminRoute>
              <AuthenticatedLayout title="Panel Administrativo" subtitle="Gestión del sistema">
                <AdminPanel />
              </AuthenticatedLayout>
            </AdminRoute>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;